module.exports = __webpack_public_path__ + "img/login-image.9188e262.png";